import React, { useState, useEffect } from 'react';
import './App.css';

interface Outfit {
  id: number;
  name: string;
  images: string[];
  description: string;
  category: string;
  sizes?: string;
  ages?: string;
}

function App() {
  const [outfits, setOutfits] = useState<Outfit[]>([
    {
      id: 1,
      name: "طقم صيفي أصفر مع جينز مزين بالقلوب",
      images: [
        "/images/model1/1001670920.jpg",
        "/images/model1/1001670919.jpg",
        "/images/model1/1001670921.jpg",
        "/images/model1/1001670914.jpg",
        "/images/model1/1001670915.jpg",
        "/images/model1/1001670926.jpg"
      ],
      description: "طقم صيفي مبهج للفتيات الصغيرات يجمع بين الأناقة والراحة. يتكون من بلوزة صفراء زاهية بكتف واحد مزينة بكشكش أنيق، مع بنطلون جينز واسع مرصع بقلوب ذهبية براقة ونثرات من الكريستال اللامع. يكتمل الطقم بحزام أصفر متناسق وحقيبة صغيرة على شكل قلب تضيف لمسة من الرقي والجاذبية. قماش البلوزة ناعم ومريح، والجينز عالي الجودة مناسب للارتداء اليومي. تصميم عصري يمنح طفلتك إطلالة مميزة في المناسبات المختلفة والخروجات اليومية.",
      category: "أطقم بناطيل",
      sizes: "8 قياسات مختلفة",
      ages: "من 4 سنوات إلى 13 سنة"
    }
  ]);
  
  const [selectedOutfit, setSelectedOutfit] = useState<Outfit | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState('الكل');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const categories = ['الكل', 'فساتين', 'أطقم عملية', 'أطقم بناطيل'];

  useEffect(() => {
    // إضافة تأثير الظهور التدريجي للعناصر عند تحميل الصفحة
    const cards = document.querySelectorAll('.outfit-card');
    cards.forEach((card, index) => {
      setTimeout(() => {
        (card as HTMLElement).style.opacity = '1';
        (card as HTMLElement).style.transform = 'translateY(0)';
      }, 100 * index);
    });
  }, [outfits]);

  const openModal = (outfit: Outfit) => {
    setSelectedOutfit(outfit);
    setCurrentImageIndex(0);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextImage = () => {
    if (selectedOutfit) {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === selectedOutfit.images.length - 1 ? 0 : prevIndex + 1
      );
    }
  };

  const prevImage = () => {
    if (selectedOutfit) {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === 0 ? selectedOutfit.images.length - 1 : prevIndex - 1
      );
    }
  };

  const filteredOutfits = activeCategory === 'الكل' 
    ? outfits 
    : outfits.filter(outfit => outfit.category === activeCategory);

  return (
    <div className="App">
      <header className="header">
        <div className="logo-container">
          <h1 className="logo">Larose Outfit</h1>
          <div className="sparkle sparkle1"></div>
          <div className="sparkle sparkle2"></div>
          <div className="sparkle sparkle3"></div>
        </div>
        <p className="tagline">أزياء عصرية بلمسة أنثوية</p>
      </header>

      <div className="categories-container">
        {categories.map(category => (
          <button 
            key={category}
            className={`category-button ${activeCategory === category ? 'active' : ''}`}
            onClick={() => setActiveCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <main className="main-content">
        {filteredOutfits.length > 0 ? (
          <div className="outfits-container">
            {filteredOutfits.map((outfit) => (
              <div 
                key={outfit.id} 
                className="outfit-card"
                onClick={() => openModal(outfit)}
              >
                <div className="outfit-image-container">
                  <img src={outfit.images[0]} alt={outfit.name} className="outfit-image" />
                  <div className="outfit-overlay">
                    <span className="view-details">عرض التفاصيل</span>
                  </div>
                </div>
                <h3 className="outfit-name">{outfit.name}</h3>
                <p className="outfit-category">{outfit.category}</p>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <p>سيتم إضافة منتجات جديدة قريباً</p>
            <p className="empty-state-sub">يرجى زيارة الموقع لاحقاً للاطلاع على أحدث التصاميم</p>
          </div>
        )}
      </main>

      {isModalOpen && selectedOutfit && (
        <div className="modal-backdrop" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={closeModal}>×</button>
            <div className="modal-body">
              <div className="modal-image-container">
                <img 
                  src={selectedOutfit.images[currentImageIndex]} 
                  alt={selectedOutfit.name} 
                  className="modal-image" 
                />
                {selectedOutfit.images.length > 1 && (
                  <div className="image-navigation">
                    <button className="nav-button prev" onClick={prevImage}>&#10094;</button>
                    <div className="image-indicators">
                      {selectedOutfit.images.map((_, index) => (
                        <span 
                          key={index} 
                          className={`indicator ${currentImageIndex === index ? 'active' : ''}`}
                          onClick={() => setCurrentImageIndex(index)}
                        ></span>
                      ))}
                    </div>
                    <button className="nav-button next" onClick={nextImage}>&#10095;</button>
                  </div>
                )}
              </div>
              <div className="modal-details">
                <h2 className="modal-title">{selectedOutfit.name}</h2>
                <p className="modal-category">التصنيف: {selectedOutfit.category}</p>
                {selectedOutfit.ages && <p className="modal-ages">الأعمار: {selectedOutfit.ages}</p>}
                {selectedOutfit.sizes && <p className="modal-sizes">المقاسات: {selectedOutfit.sizes}</p>}
                <p className="modal-description">{selectedOutfit.description}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      <footer className="footer">
        <p>جميع الحقوق محفوظة &copy; {new Date().getFullYear()} - Larose Outfit</p>
      </footer>
    </div>
  );
}

export default App;
